import { useEffect, useState } from 'react'
import { rebates, type RebateConfig } from '../../services/hostedEvents'
import { RebatesTable } from '../HostedEvents/RebatesTable'
import { errorMessage } from '../HostedEvents/helpers'
import { ErrorBanner, Spinner } from '../HostedEvents/ui'

export function Rebates() {
  const [config, setConfig] = useState<RebateConfig | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    rebates
      .config()
      .then(setConfig)
      .catch((caught) => setError(errorMessage(caught)))
  }, [])

  return (
    <div>
      <div className="mb-6">
        <h2 className="font-heading text-2xl font-bold text-gray-900 dark:text-white">
          Table Rebates
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Sponsored-table rebates across every hosted event. Review, approve, then record each
          payout.
        </p>
      </div>
      {error && <ErrorBanner message={error} />}
      {config ? <RebatesTable config={config} /> : !error && <Spinner />}
    </div>
  )
}
